import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
    HomeEnterTickets,
    NextDrawings,
    CurrentSweepstakes,
    CurrentPromotions,
    formatDateTBD,
    ErrorBoundary,
    TeleScript,
    getTelescriptItem,
    DisplayContent,
    getConfigForComponent,
} from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';
import EnterTicketTabs from '../Components/Enter/EnterTicketTabs';
import promotionConfig from '../promotionConfig';
import PointsForDrawingsSection from '../Components/PointsForDrawings/PointsForDrawings';
import LoadingIndicator from '../Components/LoadingIndicator';

const Home = ({ user, config, sweep, winner, banners, promotion, cmsSourceFirebase, actions, match, pointsForDrawings, loading }) => {
    const urlParams = new URLSearchParams(window.location.search);

    useEffect(() => {
        //? Redirect to PTA login if user is not logged in and has a hash in the url
        if (!user.loggedIn && urlParams.get('Hash')) {
            const ptaURL = window.location.protocol + '//' + window.location.host + '/login-pta' + window.location.search;
            window.location.href = ptaURL;
        }
    }, [user?.loggedIn]);

    //? Get banners for the home page
    useEffect(() => {
        if (config?.site?.banners?.homeCarousel) {
            actions?.bannerActions?.getBanners(config?.site?.banners?.homeCarousel ?? '');
        }
    }, [config?.site?.banners?.homeCarousel]);

    if (loading?.actions?.['getBanners']) {
        return <LoadingIndicator />;
    }

    const homeNextDrawing = getConfigForComponent('homeNextDrawing', config);
    const homeCurrentSweepstakes = getConfigForComponent('homeCurrentSweepstakes', config);
    const homePointsForDrawings = getConfigForComponent('pointsForDrawings', config);
    const homeCurrentPromotions = getConfigForComponent('homeCurrentPromotions', config);

    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match, banners }}>
            <div className='row justify-content-center'>
                <div className='col-lg-6 entry-box' id='home-enter-ticket-container'>
                    <ErrorBoundary fallback={<TeleScript line={getTelescriptItem('enterTickets')?.fallback} />} details={{ user, config }}>
                        <HomeEnterTickets user={user} telescript={getTelescriptItem('enterTickets')}>
                            <EnterTicketTabs />
                        </HomeEnterTickets>
                    </ErrorBoundary>
                </div>

                <DisplayContent note='Show Home Next Drawing section' isVisible={homeNextDrawing?.enabled}>
                    <div className='col-lg-6'>
                        <section id={homeNextDrawing?.hash}>
                            <ErrorBoundary fallback={homeNextDrawing?.errorBoundaryFallback} details={{ user, config }}>
                                <NextDrawings
                                    {...{ user, winner, cmsSourceFirebase, actions }}
                                    formatDate={formatDateTBD?.dateWithDayOfTheWeek}
                                    telescript={homeNextDrawing?.telescript}
                                    options={
                                        homeNextDrawing?.config ?? {
                                            variant: 'theme-primary',
                                            limitOnePerSweepstake: true,
                                            maxElement: 5,
                                        }
                                    }
                                />
                            </ErrorBoundary>
                        </section>
                    </div>
                </DisplayContent>
            </div>

            <DisplayContent note='Show Home page Current Sweepstakes / Second-Chance Promotions section' isVisible={homeCurrentSweepstakes?.enabled}>
                <div className='row justify-content-center'>
                    <div className='col-12'>
                        <section id={homeCurrentSweepstakes?.hash}>
                            <ErrorBoundary fallback={homeCurrentSweepstakes?.errorBoundaryFallback} details={{ user, config }}>
                                <CurrentSweepstakes
                                    {...{ sweep, cmsSourceFirebase, actions }}
                                    telescript={homeCurrentSweepstakes?.telescript}
                                    mode={homeCurrentSweepstakes?.config?.mode ?? 'top3_with_show_more'}
                                    promotionLink={homeCurrentSweepstakes?.config?.promotionLink ?? '/promotions'}
                                    options={
                                        homeCurrentSweepstakes?.config ?? {
                                            hasCollapser: false,
                                            variant: 'theme-primary',
                                        }
                                    }
                                />
                            </ErrorBoundary>
                        </section>
                    </div>
                </div>
            </DisplayContent>

            <DisplayContent note='Show Points For Drawings / Redeem Coin section' isVisible={homePointsForDrawings?.enabled}>
                <div className='row justify-content-center'>
                    <div className='col-12'>
                        <section id={homePointsForDrawings?.hash}>
                            <ErrorBoundary fallback={homePointsForDrawings?.errorBoundaryFallback} details={{ user, config }}>
                                <PointsForDrawingsSection {...{ actions, pointsForDrawings }} />
                            </ErrorBoundary>
                        </section>
                    </div>
                </div>
            </DisplayContent>

            <DisplayContent note='Show Home page Current Promotions / My Rewards / Achievements section' isVisible={homeCurrentPromotions?.enabled}>
                <div className='row justify-content-center'>
                    <div className='col-12'>
                        <section id={homeCurrentPromotions?.hash}>
                            <ErrorBoundary fallback={homeCurrentPromotions?.errorBoundaryFallback} details={{ user, config }}>
                                <CurrentPromotions
                                    {...{ user, config, promotion, cmsSourceFirebase, actions }}
                                    telescript={homeCurrentPromotions?.telescript}
                                    mode={homeCurrentPromotions?.config?.mode ?? 'show-limited-external-url'}
                                    options={
                                        homeCurrentPromotions?.config ?? {
                                            hasCollapser: false,
                                            variant: 'theme-primary',
                                            jurisdiction: promotionConfig?.jurisdiction,
                                        }
                                    }
                                />
                            </ErrorBoundary>
                        </section>
                    </div>
                </div>
            </DisplayContent>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
